module.exports = __webpack_public_path__ + "img/DSC_2740-xs.ddc5f7bf.png";